export default __webpack_public_path__ + "static/media/table-icon.befbfca0.svg";